import type { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
    production: false,
    appUrl: 'https://pento-uat.web.app',
    apiUrl: 'https://pento-api-925843596084.us-central1.run.app',
    keycloakUrl: 'https://keycloak-925843596084.europe-west1.run.app/realms/pento-uat',
    clientId: 'pento-app-client',
    clientSecret: undefined,
    redirectUri: window.location.origin + '/callback',
    scopes: 'openid profile email',
    publicStorageBaseUrl: 'https://storage.googleapis.com/pento-public-uat',
    netpayCdnUrl: 'https://docs.netpay.mx/cdn/v1.3/netpay.min.js',
    netpay3dsCdnUrl: 'https://cdn.netpay.mx/js/dev/netpay3ds.js',
    netpayPublicKey: 'pk_netpay_JGFtQNUFIENMlhkoBXdgiozmQ',
    netpaySandboxMode: true
};